<template>
  <div>
    <!-- <a-button type="primary" @click="showModal">Open Modal</a-button> -->
     <img src="@/assets/images/2019_firefly_TerWeb/1/icon.png" alt=""  @click="showModal">
    <a-modal title="Basic Modal" v-model="visible" @ok="handleOk">
      <video style="wdith:700px;height:410px" src="https://download.t-firefly.com/video/%E5%A4%A9%E5%90%AF%E7%A7%91%E6%8A%80%E7%AE%80%E4%BB%8B/%E5%85%AC%E5%8F%B8%E5%AE%A3%E4%BC%A0%E8%A7%86%E9%A2%91..mp4" controls poster="https://download.t-firefly.com/video/%E5%A4%A9%E5%90%AF%E7%A7%91%E6%8A%80%E7%AE%80%E4%BB%8B/bg.JPG"></video>
    </a-modal>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        visible: false,
      };
    },
    methods: {
      showModal() {
        this.visible = true;
      },
      handleOk(e) {
        console.log(e);
        this.visible = false;
      },
    },
  };
</script>


// WEBPACK FOOTER //
// src/components/Test.vue